
import GroupTitle from "./GroupTitle.js";

export default function GroupTitles (props)
{
    const groupTitles = props.groupIDS.flatMap((groupID, index, array) => {
	let result = [];

	/* if (props.simple)
	   {
	   if (index > 0) result.push(<span key={"sep-"+groupID}> / </span>);
	   }

	   else {
	   if (index > 0 && index !== array.length-1) result.push(<span key={"sep-"+groupID}>, </span>);
	   else if (index > 0) result.push(<span key={"sep-"+groupID}> et </span>);
	   }
	 */
	result.push(<GroupTitle key={groupID} variant={props.variant} groupID={groupID} determiner={true} voteCount={props.voteCount}/>);
	return result;
    });

    return (
	<div className="d-inline-flex flex-wrap gap-1">
	    {groupTitles}
	</div>
    );
}

GroupTitle.defaultProps = {
    variant: "outline-dark"
};
